export enum Pages {
    Login = '/',
    Signup = '/signup',
    SignupLinkedIn = '/signup/linkedin',
    SignupLinkedInConfirm = '/signup/linkedin/confirm',
    Invite = '/invite',
    MagicLogin = '/auth/magic-login',
    CandidateLanding = '/jobseeker',
    CandidateLandingOption1 = '/jobseeker1',
    CandidateLandingOption2 = '/jobseeker2',
    CandidateSignUp = '/jobseeker-sign-up',
    CandidateLogin = '/jobseeker/login',
    CandidateMagicLogin = '/jobseeker/auth/magic-login',
    CandidateInterview = '/jobseeker-interview',
    CandidateApply = '/jobseeker/apply',
    CandidateApplyDynamic = '/jobseeker/apply/:jobUrlId',
    CandidateApplyKit = '/jobseeker/apply/kit',
    CandidateApplyKitDynamic = '/jobseeker/apply/:jobUrlId/kit',
    HiringManagerKitSignup = '/hiring-manager/kit-sign-up',
    HiringManagerKit = '/hiring-manager/kit',
    ShareInviteFallback = '/share/:referralCode',
    Logout = '/logout',
    Roles = '/roles',
    CreateNewRole = '/create-role',
    CreateNewRoleLLM = '/create-role-llm',
    UpdateRole = '/edit-role',
    ManageRole = '/manage-role',
    ViewRole = '/view-role',
    ManageRoleHM = '/manage-role-hm',
    ManageRoleTA = '/manage-role-ta',
    CandidateReview = '/candidate-review',
    Tenants = '/tenants',
    Tenant = '/tenant',
    CreateNewTenant = '/create-tenant',
    CreateNewUser = '/create-user',
    UpdateUser = '/edit-user',
    ViewUser = '/user',
    AccessDenied = '/access-denied',
    DataManagement = '/data-management',
    HelixSearchV2 = '/search-v2',
    LLMSettings = '/llm-settings',
    Kit = '/kit',
    KitConvoDebug = '/kit/debug-console',
    KitTest = '/kit-test',
    Jobs = '/jobs',
    JobScreeners = '/job-screeners',
    JobScreener = '/job-screener',
    LlmTest = '/llm/test',
    LlmNewRole = '/llm/new-role',
    LlmRole = '/llm/role',
    AdminFeedback = '/llm/admin-feedback',
    AdminChats = '/llm/admin-chats',
}
